module.exports = __webpack_public_path__ + "img/støttelogo.d15f0e12.png";